import type { MouseEvent as ReactMouseEvent } from 'react';

import { Route } from '../route';

import {
  QUERY_STRING_GENERATED_IMAGE_SHARE_PARAMETER,
  QUERY_STRING_ORIGINAL_IMAGE_SHARE_PARAMETER,
  QUERY_STRING_REDIRECT_PARAMETER,
} from './url';

export const loginPathWithRedirectTo = (path?: string | null) => {
  const redirectTo = path
    ? `?${QUERY_STRING_REDIRECT_PARAMETER}=${encodeURIComponent(path)}`
    : '';

  return `${Route.LOGIN.path}${redirectTo}`;
};

export const urlWithImageShare = (
  url: string,
  generatedImagePath?: string,
  originalImagePath?: string,
) => {
  const searchParams = new URLSearchParams();

  if (generatedImagePath) {
    searchParams.append(
      QUERY_STRING_GENERATED_IMAGE_SHARE_PARAMETER,
      generatedImagePath,
    );
  }

  if (originalImagePath) {
    searchParams.append(
      QUERY_STRING_ORIGINAL_IMAGE_SHARE_PARAMETER,
      originalImagePath,
    );
  }

  const queryString = searchParams.toString();

  return `${url}?${queryString}`;
};

export const urlWithRedirectTo = (url: string, redirectTo: string) => {
  const redirectPath = `?${QUERY_STRING_REDIRECT_PARAMETER}=${encodeURIComponent(
    redirectTo,
  )}`;

  return `${url}${redirectPath}`;
};

/**
 * Invoke a click handler callback while still preserving native
 * behavior like right-clicking, opening in a new tab, etc.
 *
 * @param event Click event
 * @param callback Callback to invoke when not preserving native behavior such
 * as client-side routring
 */
export const preserveNativeLinking = <T>(
  event: MouseEvent | ReactMouseEvent,
  onClick: () => T,
) => {
  if (
    event.button !== 0 || // Left clicks only
    event.metaKey || // Open in new tab (macOS)
    event.ctrlKey || // Open in new tab (Windows + Linux)
    event.altKey // Download
  )
    return undefined;

  event.preventDefault();

  return onClick?.();
};
